var _style, _g, _g2, _g3, _g4, _g5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarthMaulLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0dml{fill:#791714;}\r\n\t.st1dml{fill:#929292;}\r\n\t.st2dml{fill:#A11D1D;}\r\n\t.st3dml{fill:#931913;}\r\n\t.st4dml{fill:#222323;}\r\n\t.st5dml{fill:#825716;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lag_1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0dml",
    cx: 150,
    cy: 149.9,
    r: 150
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1dml",
    d: "M84.3,104.5c3.4,0.1,6.7,0.3,10.1,0.4c0.1-3.6,0.3-7.3,0.4-10.9C86,88.8,77.2,83.6,68.4,78.4 C73.7,87.1,79,95.8,84.3,104.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1dml",
    d: "M203.7,93.4c-0.1,3.4-0.3,6.7-0.4,10.1c3.6,0.1,7.3,0.3,10.9,0.4c5.2-8.8,10.4-17.6,15.6-26.4 C221.2,82.8,212.5,88.1,203.7,93.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1dml",
    d: "M142.2,75.2c2.3,2.5,4.6,5,6.8,7.4c2.7-2.5,5.3-5,8-7.4c-2.5-9.9-5.1-19.8-7.6-29.7 C147,55.3,144.6,65.3,142.2,75.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2dml",
    d: "M93.6,82.1c-10.1,22.6-20.2,45.3-30.3,67.9c-1.8,6.5-6.8,27,4.3,39.7c0.8,0.9,1.8,1.9,2.8,2.7 c2.5,0.7,5,1.3,7.5,2c6.6,12.1,13.2,21.4,18.2,27.8c11.8,15.1,22.5,28.5,40.7,34.9c5.4,1.9,10.1,2.7,13.1,3.1 c-0.1-66-0.3-132-0.4-198c-6.8-0.1-17.4,0.6-29.5,4.9C107.7,71.4,98.9,77.7,93.6,82.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3dml",
    d: "M235.9,149.2c-11.7-23.8-23.3-47.6-35-71.4c-5.1-3.6-12.4-7.9-21.9-11.1c-11.9-4-22.4-4.6-29.4-4.5 c0.1,66,0.3,132,0.4,198c2.6-0.1,6.5-0.5,11-1.6c18.5-4.8,29.8-18.3,41.4-32.5c5.6-6.9,12.9-17,19.8-30.2c3.5-0.5,6.1-1.8,7.9-3.1 C239.9,185.9,242.1,168.5,235.9,149.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4dml",
    d: "M164.6,101.1c-4.6-5-9.2-10-13.8-15c-5.4,5-10.8,10-16.2,15c5.1,20,10.3,40.1,15.4,60.1 C154.9,141.2,159.7,121.1,164.6,101.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4dml",
    d: "M110,74.8c-5.1,6.8-10.2,13.7-15.3,20.5c0.7,6.2,5.1,10.9,10.3,11.3c4.5,0.4,8.8-2.5,10.9-7.1 C114,91.2,112,83,110,74.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1dml",
    d: "M97.9,94.9c2.3,2.5,4.6,5,6.8,7.4c2.7-2.5,5.3-5,8-7.4c-2.5-9.9-5.1-19.8-7.6-29.7 C102.7,75.1,100.3,85,97.9,94.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4dml",
    d: "M185.6,73.7c-2,8.3-4.1,16.6-6.1,24.9c3.1,5.4,9,8,13.9,6.4c4.2-1.4,7.1-5.7,7.3-10.8 C195.7,87.3,190.6,80.5,185.6,73.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1dml",
    d: "M182.7,94.9c2.3,2.5,4.6,5,6.8,7.4c2.7-2.5,5.3-5,8-7.4c-2.5-9.9-5.1-19.8-7.6-29.7 C187.5,75.1,185.1,85,182.7,94.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1dml",
    d: "M142.6,103.4c2.3,2.5,4.6,5,6.8,7.4c2.7-2.5,5.3-5,8-7.4c-2.5-9.9-5.1-19.8-7.6-29.7 C147.4,83.6,145,93.5,142.6,103.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4dml",
    d: "M157.6,157.3c2.2-3.9,8.7-1.3,17.1-5.4c5.7-2.8,9.3-7.1,11.5-10.4c6-2.4,12.2-0.4,14.7,3.9 c2.3,4,0.5,8.5,0.2,9.2c-0.1,2.8-0.7,12.7-8.3,20.6c-3.8,4-8,6-10.7,7c-3.5-0.6-11.8-2.5-18.3-9.7 C163.1,171.6,154.8,162.3,157.6,157.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4dml",
    d: "M142.3,157.3c-2.2-3.9-8.7-1.3-17.1-5.4c-5.7-2.8-9.3-7.1-11.5-10.4c-6-2.4-12.2-0.4-14.7,3.9 c-2.3,4-0.5,8.5-0.2,9.2c0.1,2.8,0.7,12.7,8.3,20.6c3.8,4,8,6,10.7,7c3.5-0.6,11.8-2.5,18.3-9.7 C136.8,171.6,145.1,162.3,142.3,157.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4dml",
    d: "M107.4,103.3c-1.2,3-2.4,5.9-3.7,8.9c9.5,9.5,19,19,28.5,28.5c-2.6,5.1-5.2,10.3-7.8,15.4 c1.3,0.6,2.6,1.1,3.9,1.7c3.1-6.3,6.2-12.5,9.3-18.8c-9.5-9.4-19-18.9-28.4-28.3c0.8-2.7,1.7-5.5,2.5-8.2 C110.3,102.8,108.8,103.1,107.4,103.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4dml",
    d: "M191.8,103.3c1.2,3,2.4,5.9,3.7,8.9c-9.5,9.5-19,19-28.5,28.5c2.6,5.1,5.2,10.3,7.8,15.4 c-1.3,0.6-2.6,1.1-3.9,1.7c-3.1-6.3-6.2-12.5-9.3-18.8c9.5-9.4,19-18.9,28.4-28.3c-0.8-2.7-1.7-5.5-2.5-8.2 C189,102.8,190.4,103.1,191.8,103.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4dml",
    d: "M162.7,235.5c-4.2,0.3-8.5,0.6-12.7,0.9c7.9-7.2,15.7-14.4,23.6-21.7c4.3,4.7,8.6,9.4,12.9,14.1 c12-17.7,24-35.5,36-53.2c-0.3-34.2,1.7-43.3,4-43.6c5.3-0.6,22.6,44,5,62c-3.4,3.5-7.3,5.2-10.4,6.2c-5,12.3-16.6,35-41,49.7 c-5.4,3.3-10.7,5.7-15.6,7.5C164,250.2,163.3,242.9,162.7,235.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4dml",
    d: "M137.3,235.5c4.2,0.3,8.5,0.6,12.7,0.9c-7.9-7.2-15.7-14.4-23.6-21.7c-4.3,4.7-8.6,9.4-12.9,14.1 c-12-17.7-24-35.5-36-53.2c0.4-35.1-1.8-43.3-4-43.6c-5.1-0.6-22,37.1-5.9,58.8c3.6,4.9,8.1,7.8,11.2,9.4 c6.2,13.3,18.8,34.8,42.9,49.4c4.9,3,9.8,5.3,14.4,7.2C136.5,249.8,136.9,242.6,137.3,235.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4dml",
    d: "M147.2,236.3c2,0,3.9,0,5.9,0c2.8,4,5.6,8.1,8.5,12.1c-1.9,1.9-3.8,3.7-5.7,5.6c0.2-2,0.3-4.1,0.5-6.1 c-2.1-1.8-4.1-3.7-6.2-5.5c-2,1.9-3.9,3.9-5.9,5.8c0,2,0.1,3.9,0.1,5.9c-2-2-3.9-3.9-5.9-5.9C141.4,244.2,144.3,240.2,147.2,236.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4dml",
    d: "M97,212.4c4.9-1.1,9.8-2.2,14.7-3.3c-0.2-6.5-0.4-13-0.6-19.6c2.9,7.3,5.9,14.6,8.8,21.9 c-6.8,1.7-13.6,3.4-20.3,5.1C98.7,215.1,97.8,213.8,97,212.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4dml",
    d: "M201.5,212.4c-4.9-1.1-9.8-2.2-14.7-3.3c0.2-6.5,0.4-13,0.6-19.6c-2.9,7.3-5.9,14.6-8.8,21.9 c6.8,1.7,13.6,3.4,20.3,5.1C199.8,215.1,200.7,213.8,201.5,212.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4dml",
    d: "M136.3,189.5c4.1,2.3,8.3,4.5,12.4,6.8c4.7-2,9.5-4,14.2-6c-4.5,4.6-9,9.2-13.4,13.8 C145.1,199.2,140.7,194.4,136.3,189.5z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_5"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5dml",
    d: "M67.7,184.8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarthMaulLogo);
export default __webpack_public_path__ + "static/media/darth-maul-logo.4be3213a.svg";
export { ForwardRef as ReactComponent };